/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Sector from 'astro/server/sector';


export default class extends Sector
{
  constructor (cass, planet)
  {
    super(cass, planet);
  }


  install ()
  {
    // no-op.
  }


  isPlatform ()
  {
    return true;
  }


};
